import { Box, List, ListItem, makeStyles } from '@material-ui/core';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const useStyles = makeStyles(_ => ({
    listItem: {
        backgroundColor: '#lightgray',
        ' &.Mui-selected': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)'
        }
    }
}));

const OpsPageSidebar : React.FC = () => {
    const history = useHistory();
    const location = useLocation();
    const classes = useStyles();
    return (
        <Box pt={1}>
            <List style={{borderRight: '1px solid #2e9e9e', marginTop: -4, height: '100vh'}}>
                <ListItem button
                        className={classes.listItem}
                        selected={location.pathname === '/ops/create-node'} onClick={() => {
                    history.push("/ops/create-node");
                }}>
                    Create Node
                </ListItem>
                <ListItem button
                        className={classes.listItem}
                        selected={location.pathname === '/ops/update-node'} onClick={() => {
                    history.push("/ops/update-node");
                }}>
                    Update Node
                </ListItem>
                <ListItem button
                        className={classes.listItem}
                        selected={location.pathname === '/ops/other'} onClick={() => {
                    history.push("/ops/other");
                }}>
                    Other
                </ListItem>
            </List>
        </Box>
    )
}

export default OpsPageSidebar;